import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TooltipContent } from './tooltip.data';

@Component({
  standalone: true,
  imports: [NgIf],
  selector: 'app-tooltip-overlay',
  template: `
    <section *ngIf="content as tooltip" class="tooltip-overlay" role="dialog" aria-label="Tooltip details">
      <h3 *ngIf="tooltip.title">{{ tooltip.title }}</h3>

      <div *ngIf="tooltip.content" class="tooltip-overlay__content" [innerHTML]="tooltip.content"></div>

      <a *ngIf="tooltip.ctaUrl && tooltip.ctaText" [href]="tooltip.ctaUrl" target="_blank" rel="noopener noreferrer">
        {{ tooltip.ctaText }}
      </a>

      <video *ngIf="tooltip.video" controls width="260">
        <source [src]="tooltip.video" type="video/mp4" />
      </video>
    </section>
  `,
  styles: [
    `
      .tooltip-overlay {
        max-width: min(420px, calc(100vw - 32px));
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 10px 36px rgba(0, 0, 0, 0.18);
        padding: 12px 14px;
        color: #2f2f2f;
      }

      .tooltip-overlay h3 {
        margin: 0 0 8px;
        font-size: 15px;
        line-height: 1.3;
        font-weight: 600;
      }

      .tooltip-overlay__content {
        font-size: 13px;
        line-height: 1.5;
      }

      .tooltip-overlay a {
        display: inline-block;
        margin-top: 10px;
        color: #1f6f8b;
        text-decoration: underline;
      }

      .tooltip-overlay video {
        display: block;
        margin-top: 10px;
        max-width: 100%;
        border-radius: 6px;
      }
    `,
  ],
})
export class TooltipOverlayComponent {
  @Input() content: TooltipContent | null = null;
}
